<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title font-weight-normal">{{ $t("Complimentary Report") }}</div>
      <div class="mt-3 mb-2">
        <div class="row">
            <div class="col-lg-5 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $tc("Cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="fromDate">✖</button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                  v-validate="'required'"
                  @selected = "onChangeDate($event, 'from')"
                  >
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("From") }}
                </label>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <button class="btn-clearDate" v-if="toDate">✖</button>
                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="toDate"
                  v-validate="'required'" :not-after="disabledAfter" :disabledDates="disabledDates">
                </Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  {{ $t("To") }}
                </label>
              </div>
            </div>
          </div>

                   <!-- User Filter -->
                     <div class="col-12 col-md-6 col-lg-2 col-xl-2 align-self-center mb-3">
                               <div class="dropdown-curve-container">
                                <label
                           :class="
                              selectedUsers && selectedUsers.length > 0
                               ? 'shift-up'
                               : 'font-weight-bold'
                           "
                           > {{ selectedUsers && selectedUsers.length > 0 ? $t("User") : $t("All Users") }}</label
                         >
                                 <multiselect
                                   :options="Users"
                                   v-model="selectedUsers"
                                   placeholder=""
                                   label="username"
                                   :multiple="true"
                                   :close-on-select="true"
                                   track-by="user_id"
                                 ></multiselect>
                               </div>
                             </div>
                <!-- User Filter -->

        
          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button class="btn-blue-lg w-100" @click.prevent="getComplimentaryReportFetch({ isPdf: 'N', isExcel: 'N' })">
              {{ $t("fetch") }}
            </button>
          </div>

          <div class="col-lg-6 col-xl-12 align-self-center mb-2 d-flex justify-content-end align-items-center"
            v-if="complimentaryData.length > 0">
            <!-- <div class="mx-1">{{ $t("download") }} as:</div> -->

            <span
                @click="getComplimentaryReportFetch({ isPdf: 'Y',isExcel:'N' })"
                title="Download as Pdf"
                style="cursor: pointer;"
              >
                <img src="@/assets/img/icons/pdf.svg" height="25" width="25" />
              </span>

            <span @click="getComplimentaryReportFetch({ isPdf: 'N', isExcel: 'Y' })" title="Download as Excel" style="cursor: pointer;">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </span>
            <!-- <span @click="excelDownload()" title="Download as Excel">
                <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
              </span> -->
          </div>
        </div>
      </div>

      <div>
         <div class="section-title font-weight-normal">{{ $t("Tickets") }}</div>
        <div v-if="complimentaryData.length > 0" style="overflow-x: scroll; width: auto !important">
          <table class="swc-report-table" border="1" id="myTable">
            <thead class="font-weight-bold">
              <tr>
              <th>Cinema name </th>
                <th>Booked By</th>
                <th>Movie</th>
                <th>Booking Date</th>
                <th>Show date</th>
                <th>Show Time</th>
                <th>Net Amount</th>
                <th>Ticket Amount</th>
                <th>Payment Mode</th>
                <th>Seats</th>
                <th>Seat Types</th>
                 <th>Customer Name</th>
                <th>Customer Email</th>
                <th>Customer Mobile</th>
          </tr>
            </thead>
            <tbody>
             <tr v-for="(ticketData, ticketDataIndex) in complimentaryData" :key="ticketDataIndex">
               <td class="text-left">{{ ticketData.cinema_name }}</td>
               <td class="text-left">{{ ticketData.booked_by }}</td>
               <td class="text-left">{{ ticketData.movie_name }}</td>
               <td class="text-right">{{ moment(ticketData.booking_date).format("YYYY-MM-DD") }}</td>
               <td class="text-right">{{ moment(ticketData.t_show_date).format("YYYY-MM-DD") }}</td>
               <td class="text-right">{{ ticketData.t_show_time }}</td>
               <td class="text-right">{{ currFormat(ticketData.ticket_net_amount) }}</td>
               <td class="text-right">{{ currFormat(ticketData.ticket_amount) }}</td>
               <td class="text-left">{{ ticketData.payment_mode }}</td>
               <td class="text-left">{{ ticketData.seats }}</td>
               <td class="text-left">{{ ticketData.seat_types }}</td>
               <td class="text-left">{{ ticketData.customer_name }}</td>
               <td class="text-left">{{ ticketData.customer_email }}</td>
               <td class="text-right">{{ ticketData.customer_mobile }}</td>
             </tr>

                   <tr class="font-weight-bold">
               <td class="text-left" colspan="6">Grand Total</td>
               <td class="text-right">{{ currFormat(complimentaryData.reduce((acc, ticket) => acc + ticket.ticket_net_amount, 0)) }}</td>
               <td class="text-right">{{ currFormat(complimentaryData.reduce((acc, ticket) => acc + ticket.ticket_amount, 0)) }}</td>
             </tr>
            </tbody>
          </table>
        </div>
        <div v-if="complimentaryData.length == 0" style="overflow-x: scroll; width: auto !important">
          <table class="swc-report-table" border="1">
            <thead class="font-weight-bold">
              <tr>
                <th>Cinema name </th>
                <th>Booked By</th>
                <th>Movie</th>
                <th>Booking Date</th>
                <th>Show date</th>
                <th>Show Time</th>
                <th>Net Amount</th>
                <th>Ticket Amount</th>
                <th>Payment Mode</th>
                <th>Seats</th>
                <th>Seat Types</th>
                <th>Customer Name</th>
                <th>Customer Email</th>
                <th>Customer Mobile</th>
              </tr>

            </thead>
            <tbody>
              <tr>
                <td colspan="9">
                  <NoRecords />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


       <div class="swc-report" style="margin-top: 50px;">
         <div class="section-title font-weight-normal">{{ $t("Concessions") }}</div>
        <table class="swc-report-table" border="1" style="table-layout: auto">
          <thead>
            <tr>
              <th>Order Code</th>
              <th>Booked By</th>
              <th>Booking Date</th>
              <th>Item Name</th>
              <th>Quantity</th>
              <th>Net Amount</th>
              <th>Total Amount</th>
              <th>Payment Mode</th>
              <th>Customer Name</th>
              <th>Customer Email</th>
              <th>Customer Mobile</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody
            v-if="
              FnbDetails.length === 0 
              
            "
          >
            <tr rowspan="12">
              <td colspan="12">
                <!-- {{ `No Records Found` }} -->
                <NoRecords />
              </td>
            </tr>
          </tbody>
          <tbody
            v-for="(
              concessionData, concessionDataIndex
            ) in FnbDetails"
            :key="concessionDataIndex"
          >

            <tr>
              <td rowspan="50">
                <strong>{{ concessionData.order_code }}</strong>
              </td>
        
            </tr>
            <tr
              v-for="(paymentMode, paymentModeIndex) in concessionData.items"
              :key="paymentModeIndex"
            >
              <td class="text-left">{{ paymentMode.booked_by }}</td>
              <td class="text-right">{{ moment(paymentMode.booking_date).format("YYYY-MM-DD") }}</td>
              <td class="text-left">{{ paymentMode.fst_item_name }}</td>
              <td class="text-right">{{ paymentMode.fst_quantity }}</td>
               <td class="text-right">{{ currFormat(paymentMode.fnb_net_amount) }}</td>
              <td class="text-right">{{currFormat(paymentMode.fnb_amount)}} </td>
              <td class="text-left">{{ paymentMode.fst_payment_mode }}</td>
              <td class="text-left">{{ paymentMode.customer_name  || "-" }}</td>
              <td class="text-left">{{ paymentMode.customer_email  || "-" }}</td>
              <td class="text-right">{{ paymentMode.customer_mobile || "-" }}</td>
              <td class="text-left">{{ paymentMode.remarks || "-" }}</td>
            </tr>

            <tr>
              <td class="text-right font-weight-bold">Total</td>
              <td></td>
              <td></td>
              <td class="text-right font-weight-bold">{{concessionData.items.reduce((acc, item) => acc + item.fst_quantity, 0)}}</td>
               <td class="text-right font-weight-bold">{{currFormat(concessionData.items.reduce((acc, item) => acc + item.fnb_net_amount,    0))}}</td>
             <td class="text-right font-weight-bold">{{currFormat(concessionData.items.reduce((acc, item) => acc + item.fnb_amount,    0))}}</td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
             <tr class="font-weight-bold text-left">
              <td colspan="4">Grand Total</td>
              <td class="text-right">{{ grandTotal.totalQuantity }}</td>
              <td class="text-right">{{ currFormat(grandTotal.fnb_net_amount) }}</td>
              <td class="text-right">{{ currFormat(grandTotal.fnb_amount) }}</td>

            </tr>
        </table>
      </div>

    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/ReportsService-v2";
import NewReportService from "../../../services/NewReportService";
import FnBReportService from "@/services/FnBReportsService";
import PosFnbService from "@/services/PosFnbService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import xlsx from "json-as-xlsx";
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  components: {
    NoRecords,
  },
  computed: {},
  data() {
    return {
          selectedUsers:[],
        Users:[],
      showNegative: "Y",
      showNegativeWatchers: "Y",
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
        selectedCinemaAddress: ""
      },
      selectedCinema: [],
      complimentaryData: [],
      FnbDetails: [],
      fromDate: new Date(),
      toDate: new Date(),
      disabledAfter: new Date(),
      grandTotal: {},
      disabledDates: {
        from: "",
      },
    };
  },
  beforeMount() {
         this.getUsers();
    this.fromDate = new Date();
  },
  watch: {
 
  },

  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
  },

  methods: {
    moment,
         async getUsers(index) {
              try {
                const response = await MasterService.GetActiveList({
                  tableName: "users",
                  is_active: "Y",
                });
                const { data } = response;
                if (data.status && data.Records.length > 0) {
                  this.Users = data.Records.filter(user=>user.role_id==4);
                 // console.log("Users",this.Users)
                } else {
                  console.log("show error:", data.message);
                }
              } catch (error) {
                this._CatchError(error);
              }
            },
    onChangeDate(e, type){
        if(type == 'from'){
          this.toDate = new Date(e);
          this.$forceUpdate();
        }
      },

  getCinemaList: function() {
        MasterService.GetCinemasByRoles()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function(event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
        this.dropDown.selectedCinemaAddress = event.cine_address
        this.$store.dispatch("selectDropdownCinema", event);
      },
    async getComplimentaryReportFetch({ isPdf, isExcel }) {
      let loader = this.$loading.show();
      try {
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinemaAddress || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          userIds : this.selectedUsers.map(x => x.user_id),
          username : this.selectedUsers.map(x => x.username),
          isPdf,
          isExcel,
        }
        let response = await NewReportService.GetComplimentaryData(payload);

        const { data } = response;
        if (data.status && data.TicketDetails.length) {
          this.complimentaryData = data.TicketDetails
          this.FnbDetails = data.FnbDetails
          this.grandTotal = data.grandTotal
          if (data.pdfPath && isPdf == "Y") {
            window.open(data.pdfPath, "_blank");
          }
          if (data.excelPath && isExcel == "Y") {
            window.open(data.excelPath, "_blank");
          }
        }
        else {
          this.$toasted.show(data.message);
        }

      }
      catch (error) {
        console.log(error)
      }
      finally {
        if (loader) {
          loader.hide()
        }
      }
    }

  },
};
</script>

<style scoped>

  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
     font-size: 12px;
  }
  .swc-report-table td {
    white-space: nowrap !important;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }

</style>


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/complimentaryReport.vue